// @ts-nocheck

import React, { useEffect, useState, useContext } from "react";

import { themes } from "../Utils/Colors";
import { APPNAME, LOGO } from "../assets/images";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom"; // assuming react-router for navigation
import { useAppDispatch, useAppSelector } from "../hooks/useRedux";
import { getUserNotifications } from "../store/userSlice";

const Notifications: React.FC = () => {
  const colors = themes["dark"];
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => state.user.token);
  const [refreshing, setRefreshing] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const fetchData = async () => {
    const resultAction = await dispatch(getUserNotifications(token));
    if (getUserNotifications.fulfilled.match(resultAction)) {
      setNotifications(resultAction.payload);
    } else {
      console.error(
        "Failed to fetch notifications:",
        resultAction.error?.message
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, token]);

  const onRefresh = async () => {
    setRefreshing(true);
    await fetchData();
    setRefreshing(false);
  };

  return (
    <div
      className="min-h-screen p-4"
      style={{ backgroundColor: colors.layoutBackground }}
    >
      {/* Custom Header */}
      <header className="flex items-center justify-between mb-6">
        <button
          onClick={() => navigate(-1)}
          className="w-10 flex justify-start items-center text-white"
          aria-label="Go Back"
        >
          <ChevronLeft size={40} />
        </button>
        <h1 className="text-white text-lg font-semibold">Notifications</h1>
        <div className="w-10" /> {/* empty placeholder for spacing */}
      </header>

      {/* Refresh button */}
      <div className="mb-4 flex">
        <button
          onClick={onRefresh}
          disabled={refreshing}
          className="ml-auto bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 disabled:opacity-50"
        >
          {refreshing ? "Refreshing..." : "Refresh"}
        </button>
      </div>

      {/* Notifications list */}
      {notifications.length === 0 ? (
        <p className="text-gray-400 text-center mt-10">No notifications yet.</p>
      ) : (
        <ul className="space-y-4">
          {notifications.map((item) => (
            <li
              key={item.notification_id}
              className="flex items-start p-4 rounded-lg bg-gray-800 border-b border-red-700 shadow-md"
              style={{ backgroundColor: colors.card }}
            >
              <img
                src={LOGO}
                alt={APPNAME}
                className="w-10 h-10 rounded-full border border-white object-contain"
              />
              <div className="ml-4 flex-1">
                <p className="text-white text-base">{item.content}</p>
                <p className="text-gray-400 text-sm mt-2">
                  {new Date(item.created_at).toLocaleString()}
                </p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Notifications;
